// The list under a combo box or a multi-select. The input keeps the focus: an option is not a
// tab stop, and its mousedown is kept from moving focus so the pick lands before the input's
// blur closes the list.

import { useEffect, useRef } from 'react';

import Icon from './Icon.jsx';

export default function OptionList({ id, label, options, active, picked = [], multiple = false, onPick }) {
  const list = useRef(null);

  // The keyboard can walk past the visible part of a long list.
  useEffect(() => {
    list.current?.querySelector('[data-active="true"]')?.scrollIntoView({ block: 'nearest' });
  }, [active]);

  return (
    <ul className="option-list" id={id} ref={list} role="listbox" aria-label={label}
        aria-multiselectable={multiple || undefined}>
      {options.length === 0 && <li className="option-none" role="presentation">Nothing matches</li>}
      {options.map((option, index) => {
        const selected = picked.includes(option.value);
        return (
          <li key={option.value} role="option" aria-selected={selected}
              className={`option${index === active ? ' active' : ''}${selected ? ' picked' : ''}`}
              data-active={index === active}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => onPick(option)}>
            <span>{option.label}</span>
            {selected && <Icon name="check" />}
          </li>
        );
      })}
    </ul>
  );
}
